export default __webpack_public_path__ + "0e4771df1d5a5f78f8a583b2348163ce.png";